module.exports = __webpack_public_path__ + "static/media/1.360e78e0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/orgasm/1.mp3
// module id = 501
// module chunks = 0